import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import { type BoundaryTerritoryGroupsAction } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.action';
import { BOUNDARY_TERRITORY_GROUP_CREATE_SUCCESS } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.actionTypes';
import { type MapSettingsBoundariesAction } from './mapSettingsBoundaries.action';
import {
  mapSettingsBoundariesClearIsolatedBoundaries, mapSettingsBoundariesSetIsolatedBoundaries,
  mapSettingsBoundaryGroupOrderGroupHoisted,
  mapSettingsBoundaryGroupOrderUpdated,
} from './mapSettingsBoundaries.actionCreators';
import {
  MAP_SETTINGS_BOUNDARIES_SET_ISOLATE_COLOR,
  MAP_SETTINGS_BOUNDARIES_SET_PRIMARY_BOUNDARY_GROUP_ID,
} from './mapSettingsBoundaries.actionTypes';
import { type MapSettingsBoundariesState } from './mapSettingsBoundaries.state';

export const mapSettingsBoundariesInitialState: MapSettingsBoundariesState = {
  boundaryGroupOrder: [],
  primaryBoundaryGroupId: null,
  isolateColor: '#ffffff',
  isolatedBoundaries: {},
};

type Action = MapSettingsBoundariesAction | BoundaryTerritoryGroupsAction;

export const mapSettingsBoundariesReducer = (state = mapSettingsBoundariesInitialState, action: Action): MapSettingsBoundariesState => {
  if (mapSettingsBoundariesSetIsolatedBoundaries.match(action)) {
    return {
      ...state,
      isolatedBoundaries: {
        [action.payload.boundaryGroupId]: action.payload.isolatedBoundariesFilter,
      },
    };
  }

  if (mapSettingsBoundariesClearIsolatedBoundaries.match(action)) {
    return {
      ...state,
      isolatedBoundaries: mapSettingsBoundariesInitialState.isolatedBoundaries,
    };
  }

  if (mapSettingsBoundaryGroupOrderUpdated.match(action)) {
    const { boundaryGroupOrder } = action.payload;

    return {
      ...state,
      boundaryGroupOrder,
    };
  }

  if (mapSettingsBoundaryGroupOrderGroupHoisted.match(action)) {
    const { boundaryGroupId } = action.payload;

    return {
      ...state,
      boundaryGroupOrder: [boundaryGroupId, ...state.boundaryGroupOrder.filter(id => id !== boundaryGroupId)],
    };
  }

  switch (action.type) {
    case BOUNDARY_TERRITORY_GROUP_CREATE_SUCCESS: {
      const newBoundaryGroupIds = action.payload.boundaryTerritoryGroups
        .filter(btg => !isDataLayersArtificialBoundaryTerritoryGroup(btg))
        .map(btg => btg.boundaryGroupId)
        .filter(id => !state.boundaryGroupOrder.includes(id));

      if (newBoundaryGroupIds.length === 0) {
        return state;
      }

      return {
        ...state,
        boundaryGroupOrder: [
          ...newBoundaryGroupIds,
          ...state.boundaryGroupOrder,
        ],
      };
    }
    case MAP_SETTINGS_BOUNDARIES_SET_PRIMARY_BOUNDARY_GROUP_ID:
      return {
        ...state,
        primaryBoundaryGroupId: action.payload.primaryBoundaryGroupId,
      };

    case MAP_SETTINGS_BOUNDARIES_SET_ISOLATE_COLOR:
      return {
        ...state,
        isolateColor: action.payload.color,
      };

    default:
      return state;
  }
};
